// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name= 'Archive Modal'] .container-mt {\r\n\t\tdisplay: flex;\r\n\t\tmargin-top: 20px;\r\n\t}\r\n\t[name= 'Archive Modal'] .container-mt > div {\r\n\t\tflex-basis: 50%;\r\n\t\talign-items: baseline;\r\n\t}\r\n\t[name= 'Archive Modal'] .mt-item-1 {\r\n\r\n\t}\r\n\t[name= 'Archive Modal'] .mt-item-2 {\r\n\t\tjustify-content: flex-end;\r\n\t}", ""]);
// Exports
module.exports = exports;
